import { Link } from "react-router-dom";

const Error = () => {
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 py-24 bg-dark-900/40 text-light-100">
      <div className="max-w-xl text-center">
        <p className="text-primary-400 font-code text-sm mb-4">404</p>
        <h1 className="text-3xl lg:text-4xl font-bold mb-4">
          This page doesn't exist
        </h1>
        <p className="text-gray-300 mb-8">
          The link may be broken or the page may have been moved. Try one of
          these instead:
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="px-6 py-3 bg-primary-500 text-dark-900 rounded-lg font-medium hover:bg-primary-600 transition-colors"
          >
            Home
          </Link>
          <Link
            to="/webscraper"
            className="px-6 py-3 border border-primary-500/40 text-primary-400 rounded-lg font-medium hover:bg-dark-800 transition-colors"
          >
            Web scraping services
          </Link>
          <Link
            to="/blog"
            className="px-6 py-3 border border-primary-500/40 text-primary-400 rounded-lg font-medium hover:bg-dark-800 transition-colors"
          >
            Blog
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Error;
